import { render, staticRenderFns } from "./EditableTextarea.vue?vue&type=template&id=6abc1e50&"
import script from "./EditableTextarea.ts?vue&type=script&lang=ts&"
export * from "./EditableTextarea.ts?vue&type=script&lang=ts&"
import style0 from "./EditableTextarea.vue?vue&type=style&index=0&id=6abc1e50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports